export default __webpack_public_path__ + "static/telco-2-b82a13204e1ddf0cc6c927ccc02d97a8.png";